import { Calendar } from 'lucide-react';
import { Button } from './ui/button';

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/mehdi-richa-formation/30min';

export const CalendlyButton = ({ 
  variant = 'default', 
  size = 'default',
  className = '',
  children = 'Prendre rendez-vous'
}) => {
  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      // Fallback: ouvrir dans un nouvel onglet
      window.open(CALENDLY_URL, '_blank');
    }
  };

  return (
    <Button
      onClick={openCalendly}
      variant={variant}
      size={size}
      className={className}
      data-testid="calendly-button"
    >
      <Calendar className="mr-2 h-4 w-4" />
      {children}
    </Button>
  );
};

export const CalendlyInline = ({ className = '' }) => {
  return (
    <div 
      className={`calendly-inline-widget ${className}`}
      data-url={CALENDLY_URL}
      style={{ minWidth: '320px', height: '700px' }}
      data-testid="calendly-inline"
    />
  );
};

// Export the URL for use in other components
export const getCalendlyUrl = () => CALENDLY_URL;

export default CalendlyButton;
